import { cn } from "@/lib/utils";

const DonutSplitLayout = ({
  chart,
  legend,
  className,
  chartClassName,
  legendClassName,
  figureTestId,
  legendTestId,
}) => (
  <div
    className={cn(
      "grid w-full min-w-0 grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(220px,320px)] lg:items-start",
      className,
    )}
  >
    <div
      className={cn(
        "relative mx-auto h-[240px] w-full min-w-0 max-w-[260px] sm:h-[280px] sm:max-w-[300px]",
        chartClassName,
      )}
      data-testid={figureTestId}
    >
      {chart}
    </div>

    <div
      className={cn(
        "w-full min-w-0 space-y-3 lg:max-h-[320px] lg:overflow-y-auto lg:pr-1",
        legendClassName,
      )}
      data-testid={legendTestId}
    >
      {legend}
    </div>
  </div>
);

export default DonutSplitLayout;
